import moment from 'moment';
let startDt = moment().subtract('1', 'M').startOf('month').format('YYYYMMDD');
let endDt = moment().subtract('1', 'M').endOf('month').format('YYYYMMDD');

let startMonth = moment().subtract('1', 'M').format('YYYYMM'); //이번년도,이번달셋팅

//let dcsnMmBe = moment(searchParams.dcsnMm).subtract('1', 'M').format('YYYYMM');

export default {
	/*이의제기 현황 시작*/
	searchParams: SEARCH_PARAMS(),
	mkObjList: [],
	prcsStepList: [], //조회조건 처리단계
	prcsRsltList: [], //조회조건 처리결과
	ctypeList: [], //조회조건 클레임타입
	gridPrcStepList: [], //그리드안에 사용여부
	pagingInfo: PAGING_INFO(),
	/*이의제기 현황 끝*/

	mkObjPopUp: MK_OBJ_POPUP(), //이의제기 팝업조회
	saveMkObjMst: MK_OBJ_POPUP(), //이의제기 저장State
	mkObjSwapPartsList: [], //이의제기 교환부품정보
	mkobTypeList: [], //이의제기 신청시 이의제기 타입
	ceqTypeList: [], //정비유형
	fileList: [], //파일첨부 디테일 조회할때
	occuRegnListPop: [], //이의제기 PWA기초 정보 발생지역
	causCdListPop: [], //이의제기 PWA기초 정보 원인코드
	ctypeList: [], //이의제기 PWA기초 정보 Ctype
	tgrpYnList: [], //이의제기 변제대상
	isSaveFlag: false,
	prcStateCd: '',
	tmpCustSaleDd: '', //임시 고객판매일자
	tmpDgnDd: '', //임시 진단일자.
	readOnlyYn: false, //협력사여부
	mkobjList:[],

	popupSearchParams: POPUP_SEARCH_PARAMS()
};

function MK_OBJ_POPUP() {
	return {
		clmNo: '', //클래임번호
		tgrpYn: '', //변제대상

		dvswRt: '', //분담율
		aplDvswRt: '', //적용분담율
		rpymAmt: '', //변제금액
		aplRpymAmt: '', //적용변제금액
		prcsStepCl: '',
		prcsStepClNm: '',
		prcsRsltCl: '',
		prcsRsltClNm: '',
		aplcIdCl: '',
		aplcDdCl: '',
		dcsnIdCl: '',
		dcsnDdCl: '',
		aplCpnyNm: '',
		rmk: '',

		roNo: '', //RO번호
		prcsStepr: '' /* RO처리단계 */,
		aplcIdr: '' /* Ro신청자ID */,
		aplcDdr: '' /* RO신청일 */,
		dcsnIdr: '' /* RO확정자ID */,
		dcsnDdr: '' /* RO확정일 */,
		roFileId: '' /*RO전용 파일Id */,
		prcsRsltr: '', //Ro처리결과,
		prcsRsltNmr: '', //Ro처리결과명
		prcsStepNmr: '', //ro처리상태명
		cmpnNo: '', //캠페인번호
		cmpnNm: '', //캠페인명
		opCd: '', //op코드
		opNm: '', //op명
		rptpNo: '', //고품분석번호
		mtrlCst: '', //자재비
		wags: '', //공임비
		incdCst: '', //부대비
		ceqStrtDd: '', //정비시작일
		ceqEndDd: '', //정비완료일

		ceqType: '', //정비유형
		pwaNo: '', //PWA번호
		prcsStepNm: '', //처리단계명
		prcStep: '', //처리단계
		aplcDd: '', //신청일
		dcsnDd: '', //확정일
		carVin: '', //VIN no
		pmcNo: '', //PMC no
		pmcId: '', //PMC Id
		vehlNm: '', //차종
		erpSaleDd: '', //HTWO판매일
		custNm: '', //판매사
		saleRegnNm: '', //판매지역
		flclSpcNm: '', //연료전지사양
		grntPlcy: '', //보증정책
		custSaleDd: '', //고객사판매일
		dlrCpnyCd: '', //딜러점코드
		dlrCpnyNm: '', //딜러점명
		rprRegn: '', //수리지역
		occuRegn: '', //발생지역
		dtlRegn: '', //지역세부
		causPartNo: '', //원인부품
		causPartNm: '', //원인부품명
		carTypeNm: '', //차종유형
		usePrd: '', //사용기간
		milg: '', //주행거리
		dgnDd: '', //진단일자
		causCd: '', //원인코드
		phmnCd: '', //현상코드
		phmnNm: '', //현상코드명
		ctype: '', //ctypeCd
		dtc1: '', //dtc1
		dtc2: '', //dtc2
		dtc3: '', //dtc3
		prtlSbc: '', //특이사항
		usePrdPo: '', //보증사용기간
		milgPo: '', //보증주행거리
		prcsRslt: '', //처리결과,
		fileId: '', //파일Id
		btnTsAuth: false, // 임시저장버튼권한
		btnApAuth: false, //신청버튼권한
		btnDelAuth: false, //삭제버튼권한
		btnApprAuth: false, //승인,반려,기각버튼권한
		readOnlyAuth: false, //리드온리구분값 신청일경우 입력못하게 함.
		readOnlyAuth1: false, //리드온리구분값 신청일경우 입력못하게 함.
		fileList: [], //파일첨부
		delFileList: [], //삭제할파일첨부
		custCplnSbc: '', //고객불만내용
		tclgDgns: '', //기술진단
		dtlSbc: '', //상세내용
		sgtn: '', //건의사항

		/*이의제기*/
		mkobType: '' /*이의제기 타입*/,
		mkobTypeNm: '' /*이의제기 타입명*/,

		bflCpnyCd: '', //이의제기 협력사
		bflCpnyNm: '', //이의제기 협력사명
		bflDvswRt1: '', //이의제기 분담율
		bflDvswRt2: '', //이의제기 적용분담율
		bflRpymAmt1: '', //이의제기 변제금액
		bflRpymAmt2: '', //이의제기 적용 변제금액

		aplCpnyCd: '', //이의제기 확정 협력사코드
		aplCpnyNm: '', //이의제기 확정 협력사명
		aplDvswRt1: '', //이의제기 확정 분담율
		aplDvswRt2: '', //이의제기 확정 적용 분담율
		aplRpymAmt1: '', //이의제기 확정 변제금액
		aplRpymAmt2: '', //이의제기 확정 적용변제금액

		dvswRtObj: '' /*이의제기 분담율*/,
		rpymAmtObj: '' /*이의제기 예상변재금액*/,
		aplDvswRtObj: '' /*이의제기 적용분담율*/,
		aplRpymAmtObj: '' /*이의제기 적용변재금액 */,

		prcsStepObj: '' /*이의제기 처리단계 */,
		prcsRsltObj: '' /*이의제기 처리결과 */,

		prcsStepNmObj: '' /*이의제기 처리단계명 */,
		prcsRsltNmObj: '' /*이의제기 처리결과명 */,

		aplcDdObj: '' /*이의제기 신청일자(제기일)*/,
		dcsnDdObj: '' /*이의제기 적용일(완료일)*/,

		mkobRson: '', //이의제기 사유
		camCpnyCd: '', //캠페인 협력사코드
		camCpnyMm: '', //캠페인 협력사명
		dlvgNm: '' //캠페인조사서
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function SEARCH_PARAMS() {
	return {
		dlrCpnyCd: '' /*협력사*/,
		roNo: '' /*RO번호*/,
		clmNo: '' /*클래임번호*/,
		causPartNo: '' /*품번*/,
		dlvgNm: '' /*실납품사*/,
		ctype: '' /*클레임타입*/,
		prcStepGb: '' /*처리단계*/,
		prcRsltCd: '' /*처리결과*/,
		startDcsnDd: '' /*확정일자from*/,
		endDcsnDd: '' /*확정일자to*/,
		startAplcDdObj: '' /*이의제기일from*/,
		endAplcDdObj: '' /*이의제기일to*/,
		startDcsnDdObj: '' /*이의처리 완료일from*/,
		endDcsnDdObj: '' /*이의처리 완료일to*/,
		initStartDt: startDt, //초기값 시작일자
		initEndDt: endDt, //초기값 종료일자
		initStartMonth: startMonth,
		mkobjCd:'',
		strtMm01:'',
		endMm01:''
	};
}
function POPUP_SEARCH_PARAMS() {
	return {
		dlrCpnyCd: '' /*딜러점*/,
		carVin: '' /*차량VIN*/,
		pwaNo: '' /*PWA번호*/,
		prcsRslt: '10' /*처리결과*/
	};
}

export { SEARCH_PARAMS, MK_OBJ_POPUP, PAGING_INFO, POPUP_SEARCH_PARAMS };
